<div class="modal-header"></div>
<div class="modal-body">
    <div class="invalid-tick"></div>
    <h3>{{ message || 'บันทึกข้อมูลเรียบร้อยแล้ว' }}</h3>
    <p class="description" *ngIf="description">
        {{ description.text }}
        <a *ngIf="description.linkText" [routerLink]="[description.linkUrl || '/']">
            {{ description.linkText }}
        </a>
    </p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onSubmit()">OK</button>
</div>
